var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.00781C3.61758 1.00781 0.875 3.75039 0.875 7.13281C0.875 10.5152 3.61758 13.2578 7 13.2578C10.3824 13.2578 13.125 10.5152 13.125 7.13281C13.125 3.75039 10.3824 1.00781 7 1.00781ZM7 12.2188C4.1918 12.2188 1.91406 9.94102 1.91406 7.13281C1.91406 4.32461 4.1918 2.04688 7 2.04688C9.8082 2.04688 12.0859 4.32461 12.0859 7.13281C12.0859 9.94102 9.8082 12.2188 7 12.2188Z",
    fill: "#A8A29E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34354 4.72656C6.34354 4.90061 6.41268 5.06753 6.53575 5.1906C6.65882 5.31367 6.82574 5.38281 6.99979 5.38281C7.17383 5.38281 7.34075 5.31367 7.46382 5.1906C7.5869 5.06753 7.65604 4.90061 7.65604 4.72656C7.65604 4.55251 7.5869 4.38559 7.46382 4.26252C7.34075 4.13945 7.17383 4.07031 6.99979 4.07031C6.82574 4.07031 6.65882 4.13945 6.53575 4.26252C6.41268 4.38559 6.34354 4.55251 6.34354 4.72656ZM7.32791 6.25781H6.67166C6.61151 6.25781 6.56229 6.30703 6.56229 6.36719V10.0859C6.56229 10.1461 6.61151 10.1953 6.67166 10.1953H7.32791C7.38807 10.1953 7.43729 10.1461 7.43729 10.0859V6.36719C7.43729 6.30703 7.38807 6.25781 7.32791 6.25781Z",
    fill: "#A8A29E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.e8488dee6fe12e5cc3fb6be4944c1c41.svg";
export { ForwardRef as ReactComponent };